/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ShareActivityAlert_user$ref: FragmentReference;
export type ShareActivityAlert_user = {|
  +serviceId: ?string,
  +preferences: ?{|
    +shareActivities: ?any
  |},
  +$refType: ShareActivityAlert_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ShareActivityAlert_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preferences",
      "storageKey": null,
      "args": null,
      "concreteType": "UserPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shareActivities",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1f8e6e09353d2c2af6a4d8f829b056a1';
module.exports = node;
